<template>
    <div v-if="ready" class="row mx-auto mt-6 max-w-2xl">
        <div class="col-lg-5 col-12">
            <div class=" p-3 pb-1 border-b border-gray-100 text-center  bitacora-header">
                        <h4 class="display-4">Registra tu gestión: 😉 </h4>
                        <h4 class="mb-3 pt-2"  > {{ this.beneficiario }}</h4>
                        <p class="pt-2 ">Aqui puedes agregar los comentarios de las gestiones hechas como:</p>
                        <p> Promesas de pagos, visitas en campo, llamadas realizadas, entre otros.</p>

                    </div>

                    <div class="px-0 pb-0 px-sm-5 pb-sm-6 create-registro">
                        <div class="mb-6">
                            <textarea v-model="nuevoRegistro.comentario" placeholder="Escribe un nuevo comentario..."
                                class="w-full border border-gray-300 rounded-md p-3 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                                rows="3"></textarea>

                            <div class=" row d-flex justify-content-between align-items-center  mt-3">
                                <div class="col-lg-4 col-12">
                                    <select v-model="nuevoRegistro.idTipoGestion"
                                        class="border border-gray-300 p-2 rounded-md w-1/2 ms-2">
                                        <option disabled value="">Tipo de gestión</option>
                                        <option v-for="tipo in tiposGestion" :key="tipo.id" :value="tipo.id">
                                            {{ tipo.nombre }}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-12 col-lg-4 mt-sm-0 mt-3"> 

                                    <input v-if="nuevoRegistro.idTipoGestion == 1" v-model="nuevoRegistro.montoPromesa"
                                        type="number" step="0.01" placeholder="Promesa (Lps)"
                                        class="border border-gray-300 ms-2 p-2 rounded-md w-1/2" />
                                </div>

                                <div class="col-12 col-lg-4 mt-sm-0 mt-3"> 
                                    <input v-if="nuevoRegistro.idTipoGestion == 1" v-model="nuevoRegistro.fechaPromesa" type="date"
                                        placeholder="Promesa (Lps)" class="border border-gray-300 ms-2 p-2 rounded-md " />
                                </div>


                                <button @click="crearRegistro" class="btn btn-primary mt-3" style="color: white;">
                                    Publicar
                                </button>
                            </div>
                        </div>
                    </div>
        </div> 

        <div class="col-lg-6 col-12 ">

            
            
            <div v-if="Array.isArray(bitacora) && bitacora.length === 0" class="text-gray-500 text-sm text-center py-4">
            No hay registros aún.
        </div>

        <div v-else class="space-y-5">
            <div v-for="item in bitacora" :key="item.id" class="comment-card">
                <div class="comment-meta">
                    <div class="d-flex"><strong>{{ item.tipoGestion }}</strong>
                        <div v-if="item.idTipoGestion == 1">– {{ this.formatoNumero(item.montoPromesa) }} {{ this.moneda
                            }} – {{ this.dateFormat(item.fechaPromesa) }}</div>
                    </div>
                    <div>{{ this.dateFormat(item.createdAt) }}</div>
                </div>
                <p class="comment-text">{{ item.comentario }}
                    

                </p>
                <!-- <div class="comment-actions">
                    <cite style="font-size: 13px; color: #212121;">- {{ item.nombreUsuario }}</cite>
                </div> -->
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import Security from '../security';
import { store } from '../store';

export default {
    name: 'BitacoraApp',
    props: {
        idCredito: {
            type: Number,
            required: true,
        },
        idUsuario: {
            type: Number,
            required: true,
        },
        beneficiario: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            bitacora: [],
            tiposGestion: [],
            nuevoRegistro: {
                comentario: '',
                idTipoGestion: '',
                montoPromesa: '',
                fechaPromesa: this.getTodayDate(),
            },
            ready: false,
            store,
            moneda: 'lps',
        };
    },
    mounted() {
        console.log("Montando el componente BitacoraApp con idCredito:", this.idCredito);
        this.obtenerTiposGestion();
        this.obtenerRegistros();
    },
    methods: {
        async obtenerTiposGestion() {
            try {
                const res = await fetch(
                    process.env.VUE_APP_API_URL + "/admin/tipos-gestion/get-Tipos",
                    Security.requestOptions({})
                );
                const response = await res.json();
                if (!response.error) {
                    this.tiposGestion = response.data.tiposGestion;
                    console.log("Tipos de gestión obtenidos:", this.tiposGestion);
                } else {
                    this.$emit('error', response.message);
                }
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: error,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        async obtenerRegistros() {
            try {
                const res = await fetch(
                    process.env.VUE_APP_API_URL + '/admin/bitacora/credito',
                    Security.requestOptions({ idCredito: this.idCredito })
                );
                const response = await res.json();
                if (!response.error) {
                    this.bitacora = response.data.registros || [];
                } else {
                    this.$emit('error', response.message);
                }
                this.ready = true;
            } catch (error) {
                this.$emit('error', error);
                this.ready = true;
            }
        },
        async crearRegistro() {
            if (!this.nuevoRegistro.comentario || !this.nuevoRegistro.idTipoGestion) {
                alert('Debe ingresar comentario y tipo de gestión');
                return;
            }

            const payload = {
                idUsuario: this.idUsuario,
                idCredito: this.idCredito,
                comentario: this.nuevoRegistro.comentario,
                idTipoGestion: this.nuevoRegistro.idTipoGestion,
                montoPromesa: parseFloat(this.nuevoRegistro.montoPromesa) || 0,
                fechaPromesa: this.toGoISOString(this.nuevoRegistro.fechaPromesa) || null,

                celularCliente: '',
            };

            try {
                const res = await fetch(
                    process.env.VUE_APP_API_URL + '/admin/bitacora',
                    Security.requestOptions(payload)
                );
                const response = await res.json();
                if (!response.error) {
                    this.nuevoRegistro.comentario = '';
                    this.nuevoRegistro.idTipoGestion = '';
                    this.nuevoRegistro.montoPromesa = '';
                    this.obtenerRegistros();
                } else {
                    this.$emit('error', response.message);
                }
            } catch (error) {
                this.$emit('error', error);
            }
        },
        async eliminarRegistro(id) {
            try {
                const res = await fetch(
                    process.env.VUE_APP_API_URL + '/admin/bitacora',
                    Security.requestOptions({ id })
                );
                const response = await res.json();
                if (!response.error) {
                    this.obtenerRegistros();
                } else {
                    this.$emit('error', response.message);
                }
            } catch (error) {
                this.$emit('error', error);
            }
        },
        formatDate(fecha) {
            return new Date(fecha).toLocaleString('es-HN');
        },
        toGoISOString(dateStr) {
            // Asegura que se use medianoche UTC (sin aplicar la hora local)
            return `${dateStr}T00:00:00Z`;
        },
        formatoNumero(numero) {
            return new Intl.NumberFormat("en-US").format(numero)
        },
        dateFormat(param) {

            var fechaISO = param;

            // Crear un objeto Date con la fecha proporcionada
            var fecha = new Date(fechaISO);

            // Obtener el día del mes (agregando un cero inicial si es necesario)
            var dia = ('0' + fecha.getUTCDate()).slice(-2);

            // Obtener el mes (agregando un cero inicial si es necesario)
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

            // Obtener el año
            var anio = fecha.getUTCFullYear();

            // Formatear la fecha según tus necesidades
            var fechaFormateada = dia + '/' + mes + '/' + anio;

            console.log(fechaFormateada); // Salida: 01/12/2023

            return fechaFormateada;

        },
        getTodayDate() {
        const today = new Date()
        return today.toISOString().slice(0, 10) // Formato 'YYYY-MM-DD'
        },
    },
};
</script>

<style scoped>
.bitacora-wrapper {
    background-color: #fff;
    border-radius: 1rem;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    overflow: hidden;
}

.create-registro {
    background-color: #f3f4f6;
    border-radius: 0.75rem;
    padding: 1rem;
    margin: 1rem;

}

textarea {
    background-color: #ffffff;
    font-size: 0.875rem;
    line-height: 1.25rem;
    border-radius: 5px;
    width: 100%;
}

select,
input[type="number"] {
    background-color: #fff;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

button {
    font-size: 0.875rem;
    transition: background-color 0.2s;
}

button:hover {
    cursor: pointer;
}

.comment-card {
    background-color: #ffffff;
    border: 1px solid #f3f4f6;
    border-radius: 0.75rem;
    margin: 1rem;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    
}

.comment-meta {
    font-size: 0.7rem;
    color: #6b7280;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.25rem;
}

.comment-text {
    margin-top: 5px; 
    width: 85%;
    color: #1f2937;
    font-size: 0.875rem;
    white-space: pre-wrap;        /* respeta saltos de línea manuales */
    word-wrap: break-word;        /* rompe palabras largas */
    overflow-wrap: break-word;    /* para compatibilidad */
}

.comment-actions {
    text-align: right;
    margin-top: 0.5rem;
}

.comment-actions button {
    color: #ef4444;
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.375rem;
    background-color: transparent;
    border: none;
}

.comment-actions button:hover {
    background-color: #fee2e2;
}
.bitacora-header{
                   /* Tamaño de fuente fijo de 12px */
    line-height: 1.5;              /* Altura de línea: 1.5 veces el tamaño de la fuente */
    word-wrap: break-word;         /* Permite romper palabras largas al llegar al borde del contenedor (alias de overflow-wrap) */
    overflow-wrap: break-word;     /* Lo mismo que word-wrap, recomendado por ser el estándar moderno */
    white-space: wrap;             /* ❌ Este valor NO existe en CSS. Es un error. */
    padding-left: 0%;              /* No deja espacio a la izquierda */
}
</style>
